
// media Queries variables

var mediaQueries = false;
var activeMediaQuery = 'none';

module.exports = {mediaQueries, activeMediaQuery};
